import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import { AppErrors, NotFoundError } from '@fitness-force/models';;

import { environment } from '@fitness-force/environments';
import { throwError, Observable, pipe } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';

import type { AppointmentTypeList, CreateResponse } from '@fitness-force/models';

@Injectable({
  providedIn: 'root',
})
export class AdHocService {
  private http = inject(HttpClient);
  private router = inject(Router);

  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  createAdHocCharges(
    tenantId: number,
    chargesPayload: any
  ) {
    return this.http
      .post(
        environment.BASE_URL + CONST_URL_SEGEMENTS.AD_HOC.CREATE_AD_HOC
          .replace('{tenant_id}', tenantId.toString()),
        chargesPayload,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


  updateAdHocCharges(
    tenantId: number,
    adHocId: number,
    chargesPayload: any
  ) {
    return this.http
      .put(
        environment.BASE_URL + CONST_URL_SEGEMENTS.AD_HOC.UPDATE_AD_HOC
          .replace('{tenant_id}', tenantId.toString())
          .replace('{ad_hoc_id}', adHocId.toString()),
        chargesPayload,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markActive(tenantId: number, appt_type_id: number) {
    return this.http
      .post(
        environment.BASE_URL + CONST_URL_SEGEMENTS.APPOINTMENT_TYPE.MARK_APPOINTMENT_TYPE_ACTIVE
          .replace('{tenant_id}', tenantId.toString())
          .replace('{appt_type_id}', appt_type_id.toString()),
        {},
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markInActive(tenantId: number, appt_type_id: number) {
    return this.http
      .post(
        environment.BASE_URL + CONST_URL_SEGEMENTS.APPOINTMENT_TYPE.MARK_APPOINTMENT_TYPE_INACTIVE
          .replace('{tenant_id}', tenantId.toString())
          .replace('{appt_type_id}', appt_type_id.toString()),
        {},
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
  getAdhocList(tenantId: number ) {
    return this.http
      .get(
        environment.BASE_URL + CONST_URL_SEGEMENTS.AD_HOC.GET_AD_HOCS
          .replace('{tenant_id}', tenantId.toString()),
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getAppointmentTypes(
    tenantId: number,
    allParams: Array<string>
  ): Observable<AppointmentTypeList> {
    let parsedParams = new HttpParams();
    if (allParams.length > 0) {
      allParams.forEach((p: any) => {
        parsedParams = parsedParams.append(p.name, p.value);
      });
    }
    const url =
      this.BASE_URL +
      CONST_URL_SEGEMENTS.SCHEDULING.APPOINTMENT_TYPE.GET_APPOINTMENT_TYPES.replace(
        '{tenant_id}',
        tenantId.toString()
      );
    return this.http
      .get(url, { headers: this.httpOptions.headers, params: parsedParams })
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
}
